import React from 'react';
import styled from 'styled-components';
import { gridConfig } from '@tvg/fuse-design';
import { useSelectedSkuContext } from 'context/SelectedSku/SelectedSkuContext';
import { ProductPriceAmount } from 'types/Product';
import { getPriceWithSymbol } from 'utilities/price/price-utilities';
import VisiblyHidden from '../VisiblyHidden';
import { isNotInStock } from '../../utilities/util';

const Container = styled.div`
  margin-bottom: var(--spacing-space16);
  order: 0;

  @media (min-width: ${gridConfig.m.minWidth}) {
    order: 1;
  }
`;

const CurrentPrice = styled.p`
  font-weight: bold;
  color: var(--color-global-black);
  font-size: var(--font-size-3);
`;

interface DynamicPriceProps {
  price: ProductPriceAmount;
}

function DynamicPrice({ price }: DynamicPriceProps) {
  const { selectedSku, selectedInsurance, isInsuranceAvailable, filteredLinkedAddonServicesContent } =
    useSelectedSkuContext();
  const { currentFrom } = price;
  const getCurrentPriceText = () => {
    const basePrice = selectedSku?.price.amount.current;
    const InsurancePrice = selectedInsurance?.offer?.sellingPrice;
    const addonPrices = filteredLinkedAddonServicesContent?.filter((x) => x.isSelected === true).map((x) => x.price);
    const totalAddonPrice = addonPrices?.reduce((acc, current) => acc + (current.now?.basePrice || 0), 0);

    const basePriceToNumber = selectedSku?.price.amount.unformattedPrice;

    let total = basePriceToNumber;

    if (total) {
      total += totalAddonPrice ?? 0;
    }

    if (InsurancePrice && total) {
      total += InsurancePrice;
    }

    if (total) {
      return getPriceWithSymbol(total, price.currencyCode);
    }

    return basePrice;
  };
  const renderCurrent = () => {
    const text = getCurrentPriceText();
    const accessibilityText = text && `Total price ${text}`;

    return (
      <>
        <CurrentPrice data-testid="dynamic-price" aria-hidden>
          {text}
        </CurrentPrice>
        <VisiblyHidden text={accessibilityText} />
      </>
    );
  };

  return (currentFrom || isInsuranceAvailable) && selectedSku && !isNotInStock(selectedSku.stock?.code) ? (
    <Container>{renderCurrent()}</Container>
  ) : null;
}

export default DynamicPrice;
